<template>
	<div>
		<el-dialog :visible.sync="showinterceptwin" title="设置拦截" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
			<div style="height:200px;" class="intercept">
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="拦截原因">
						<el-select style="width:100%" v-model="form.intercept" placeholder="请选择拦截原因">
							<el-option v-for="item in interceptlist" :key="item.d_name" :label="item.d_name" :value="item.d_name"></el-option>
						</el-select>
					</el-form-item>
<!-- 					<el-form-item label="备   注"><el-input type="textarea" rows="4" v-model="form.remark"></el-input></el-form-item> -->
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<div style="text-align: center;width:100%">
					<el-button size="mini" type="success" @click.native="setintercept">确定</el-button>
					<el-button size="mini" type="info" plain @click.native="showinterceptwin=false">关闭</el-button>
				</div>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	components: {},
	data() {
		return {
			form: {
				intercept: '',
				remark: ''
			},
			showinterceptwin: false,
			searchinfo: '',
			batch: '',
			pageparam: {},
			interceptlist: []
		};
	},
	mounted() {},
	methods: {
		init(param) {
			var that = this;
			if (param.searchinfo != undefined) that.searchinfo = param.searchinfo;
			if (param.batch != undefined) that.batch = param.batch;
			if (param.pageparam != undefined) that.pageparam = param.pageparam;
			that.showinterceptwin = true;
			//获取拦截类型
			this.$apipost.get.dic({ type: '拦截类型' }).then(res => {
				if (res.data != '') {
					console.log('拦截类型', res.data);
					that.interceptlist = res.data.list;
				}
			});
		},
		//设置拦截
		setintercept() {
			var that=this;
			var isgo=true;
			if(that.form.intercept==''){
				this.$tool.message('请选择拦截原因', 0);
				isgo= false;
			}
			//获取拦截原因限定的订单个数
			var intercept=this.interceptlist.filter(function(e) {
				return e.d_name==that.form.intercept;
			});
			if(intercept.length>0){
				var value=intercept[0].d_value;
				if(value=='仅一单'){
					if(this.pageparam.yxcount>1||(this.pageparam.checkedrow.length>1||(this.pageparam.selectedall&&this.pageparam.packagelist.length>1))){
						this.$tool.message('仅允许操作一个订单', 0);
						isgo= false;
					}
				}
				else if(value=='一单以上'){
					if(this.pageparam.yxcount<2&&(this.pageparam.checkedrow.length<2&&(this.pageparam.selectedall&&this.pageparam.packagelist.length<2))){
						this.$tool.message('必须操作一单以上', 0);
						isgo= false;
					}
				}
			}else
				isgo=false;
			if (isgo){
				this.$tool.loading('正在设置', 'intercept');
				this.$apipost.post.OrderIntercept({paraminfo:this._data}).then(res => {
					this.$tool.loadingclose();
					if (res!= '') {
						if(res.state=='1'){
							this.$tool.message(res.message, 1);
							that.showinterceptwin=false;
							that.$parent.refreshgrid(true);
						}else{
							this.$tool.message(res.message, 0);
						}
					}
				});
			}
		}
	}
};
</script>
<style></style>
